(function () {
  angular.module("akitabox.ui.dialogs.bulkAdd.relationships", [
    "akitabox.core.utils",
    "akitabox.core.toast",
    "akitabox.core.services.association",
    "akitabox.core.services.organization",
    "akitabox.core.services.associationType",
  ]);
})();
